<script>
/**
 * Footer component
 */
export default {
  name: 'Footer'
}
</script>
<style>
  a:hover
  {
    cursor: pointer;
  }
  img {
  pointer-events: none;
}

</style>
<style scoped>
h4
{
  color: #000000c4;
} 
</style>
<template>
  <div>
    <!--START FOOTER-->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 margin-t-20">
            <h4>FANMATH</h4>
            <div class="text-muted margin-t-20">
              <ul style="margin-top: 10.9%" class="list-unstyled footer-list">
               <p style="color: #000000a3">Заповядайте в един по-нетрадиционен курс по математика!</p>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Полезни връзки</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <router-link class="nav-link" to="/" style="padding: 0 !important;"> <a class="footer-items" style="color: #000000a3" href="">За нас</a></router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/задачи" style="padding: 0 !important;"> <a style="color: #000000a3" href="">Примерни задачи</a></router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/курсове" style="padding: 0 !important;"> <a style="color: #000000a3" href="">Курсове</a></router-link>
                </li>
                <li>
                  <router-link class="nav-link" to="/преподавател" style="padding: 0 !important;"> <a style="color: #000000a3" href="">Преподавател</a></router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Свържете се с нас</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <!-- <li>
                  <a >Адрес: </a>
                </li> -->
                <li>
                  <a style="color: #000000a3" >Телефонен номер: +359 889 469 526</a>
                </li>
                <li>
                  <a style="color: #000000a3" >Имейл адрес: tanilieva@mail.bg</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p
                class="copy-rights text-muted mb-3 mb-sm-0" style="color: #000000a3 !important;"
              >{{ new Date().getFullYear()}} © FANMATH</p>
            </div>
            <div class="float-right pull-none">
              <ul class="list-inline social m-0">
                <li class="list-inline-item">
                  <a href="https://www.facebook.com/profile.php?id=100086725862827" target="_blank" class="social-icon">
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li> -->
                <li class="list-inline-item">
                  <a href="https://www.instagram.com/fanmathty/" class="social-icon">
                    <i class="mdi mdi-instagram"></i>
                  </a>
                </li>
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-google-plus"></i>
                  </a>
                </li> -->
                <!-- <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-dribbble"></i>
                  </a>
                </li> -->
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>